import Color from 'color'

export function fromHexToAhex(color: string, opacity = 1): string {
  const alphaOpacity = Math.ceil(Number(255 * opacity))
    .toString(16)
    .toUpperCase()

  return ['#', alphaOpacity, color.slice(1)].join('')
}

export function fromAhexToHexa(color: string): string {
  if (color.length === 4 || color.length === 7) {
    return color
  }

  const isShortColor = color.length <= 5 ? 2 : 3

  return ['#', color.slice(isShortColor), color.slice(1, isShortColor)].join('')
}

export function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
      result[3],
      16,
    )})`
    : null
}

export function toColor(ahexColor: string, isHexa = false): Color | undefined {
  try {
    if (ahexColor.indexOf('#') === 0) {
      return new Color(!isHexa ? fromAhexToHexa(ahexColor) : ahexColor)
    }

    return new Color(ahexColor)
  } catch (e) {
    console.log(e)
    return new Color('rgba(0, 0, 0, 0)')
  }
}

export function toAHEX(hexacolor: Color): string {
  return fromHexToAhex(hexacolor.hex(), hexacolor.rgb().alpha())
}

export function colorToRGBA(color: Color, opacity: number) {
  return color
    .rgb()
    .toString()
    .replace(
      /rgb\(([0-9]+, [0-9]+, [0-9]+)\)/,
      (replace, m1) => `rgba(${m1}, ${opacity})`,
    )
}

export function hexToRGBA(hex, opacity) {
  // Remove the hash (#) sign if it exists
  hex = hex.replace('#', '');

  // Parse the hex color string
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Return the formatted RGBA string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}